import QuickSearch from "./QuickSearch";
import { QuickSearchProps } from "./IQuickSearch";

export type { QuickSearchProps };
export default QuickSearch;
